import {Plans} from './Plans'
import {Account} from './Account'
import {Users} from './Users'
import {Features} from './Features'
import {Brands} from './Brands'
import {Oppositions} from './Oppositions'
import {Owners} from './Owner'
import {Documents} from "./Documents";
import {OppositionDocuments} from "./OppositionDocuments";
import {Imports} from "./Imports";
import {Matches} from "./Matches";
import {Home} from "./Home";
import {Trademarks} from "./Trademarks";
import {Tags} from "./Tags";

export const actions = {
    ...Plans, ...Account, ...Users, ...Features, ...Brands, ...Oppositions, ...Owners, ...Documents, ...OppositionDocuments, ...Imports, ...Matches, ...Home, ...Trademarks, ...Tags
};
